import { Product } from 'src/app/order/models/product.model';
import { WarehouseLocation } from './warehouse-location.model';
import { ProductStockMovementReference } from './product-stock-movement-reference.model';

export const MOVEMENT_IN = 'in';
export const MOVEMENT_OUT = 'out';
export const MOVEMENT_TRANSFER_IN = 'transfer-in';
export const MOVEMENT_TRANSFER_OUT = 'transfer-out';
export const MOVEMENT_ADJUSTMENT = 'adjustment';

/** The types the backend writes, for display and for filtering the ledger. */
export const MOVEMENT_TYPE_LABELS: any[] = [
  {value: MOVEMENT_IN, label: 'Goods In'},
  {value: MOVEMENT_OUT, label: 'Goods Out'},
  {value: MOVEMENT_TRANSFER_IN, label: 'Transfer In'},
  {value: MOVEMENT_TRANSFER_OUT, label: 'Transfer Out'},
  {value: MOVEMENT_ADJUSTMENT, label: 'Adjustment'}
];

/**
 * Decimals a weight is stored to, and therefore the only decimals a screen may show.
 *
 * The column is DECIMAL(12,3) — kilograms to the gram. Used for formatting alone: a JS subtraction
 * or sum over weights reads back with binary-float noise the column cannot hold, and cutting it at
 * the column's own scale loses nothing real. NOT a tolerance and never used as one; weight is exact
 * in the database, so it has no epsilon, no noise floor and nothing in common with the `qty` path.
 */
export const WEIGHT_DECIMALS: number = 3;

export class ProductStockMovement {
  id: number = -1;

  productId: number = -1;
  product: Product = new Product();

  warehouseLocationId: number = -1;
  warehouseLocation: WarehouseLocation = new WarehouseLocation();

  movementType: string = '';

  referenceId: number = -1;
  reference: ProductStockMovementReference = new ProductStockMovementReference();

  qty: number = 0;

  /**
   * What the goods weighed before and after this movement, or null where they were not weighed —
   * which is the normal case, so null here is data rather than a gap.
   *
   * Initialised to null and not 0: zero is a real reading off a tared scale, so a screen that
   * rendered "not weighed" as 0 would be stating a measurement nobody took. Net is
   * `endWeight - startWeight` and is not a column — a movement weighed once has no net.
   *
   * Metadata on the ledger row. It keys no stock level, gates nothing and is consulted by no check:
   * a weight is recorded for reporting and enforced nowhere.
   */
  startWeight: number = null;
  endWeight: number = null;

  createdBy: number = -1;
  createdAt: string = '';
  updatedAt: string = '';
}
